import SplitPanel from './src/SplitPanel';

export default SplitPanel;
